import { withInstall, withInstallDirective } from '@sgui-plus/utils'

import Popover from './src/popover.vue'
import PopoverDirective, { VPopover } from './src/directive'

export const SgPopoverDirective = withInstallDirective(
  PopoverDirective,
  VPopover
)

export const SgPopover = withInstall(Popover, {
  directive: SgPopoverDirective,
})
export default SgPopover

export * from './src/popover'
